import { clamp } from './math.js'

/** 메타데이터 대기·라이브 스트림의 무한 길이도 유효한 0~1 값으로 처리한다. */
export function playbackProgress(time: number, duration: number): number {
  if (!Number.isFinite(time) || !Number.isFinite(duration) || duration <= 0) return 0
  return clamp(time / duration, 0, 1)
}
